import cx from 'classnames';
import Lottie from 'lottie-react';
import { MouseEvent } from 'react';

import { LoaderAnimation } from '../../../animations';
import { ITableCell, ITableProps, ITableRow } from './types';

export const Table = ({ rows, header, onRowClick, id = '', className = '', loading = false }: ITableProps) => {
  const onClick = (row: ITableRow, event: MouseEvent<HTMLDivElement>) => {
    if (onRowClick) onRowClick(row.id, event);
  };

  const getColumnWrapper = ({ element: column, minWidth }: ITableCell, index: number, itemsCount: number) => {
    const style = { minWidth: `${minWidth ?? 100 / itemsCount}%` };

    if (column.type === 'span') {
      return (
        <div key={index} style={style} className="flex typography-inline-highlight-3 text-text-primary pr-4">
          {column}
        </div>
      );
    } else {
      return (
        <div style={style} key={index}>
          {column}
        </div>
      );
    }
  };

  const getHeaderColumnWrapper = ({ element: column, minWidth }: ITableCell, index: number, itemsCount: number) => {
    const style = { minWidth: `${minWidth ?? 100 / itemsCount}%` };
    return (
      <div key={index} style={style} className="flex typography-title-3 text-text-tertiary">
        {column}
      </div>
    );
  };

  return (
    <div id={id} className={className}>
      <div className="flex h-[48px] items-center border-b border-border-divider">
        {header.map((column: ITableCell, columnIndex: number) =>
          getHeaderColumnWrapper(column, columnIndex, header.length),
        )}
      </div>

      {loading ? (
        <div className="flex h-[168px] items-center justify-center">
          <Lottie animationData={LoaderAnimation} className="h-[120px] w-[120px]" />
        </div>
      ) : (
        rows.map((row: ITableRow) => (
          <div
            key={row.id || row.key}
            className={cx(
              'flex w-full h-[48px] items-center border-b border-border-divider hover:bg-global-zurich-10',
              onRowClick && 'cursor-pointer',
            )}
            onClick={(event) => onClick(row, event)}
          >
            {row.elements.map((column: ITableCell, columnIndex: number) =>
              getColumnWrapper(column, columnIndex, row.elements.length),
            )}
          </div>
        ))
      )}
    </div>
  );
};
